module.exports = __webpack_public_path__ + "img/6.25f99a8f.png";